import {BopisController} from 'custom-extensions/bopis';
import {LitElement, html, nothing} from 'lit';
import styles from './MyStoreFlag.component.scss?as=stylesheet';

export default class MyStoreFlag extends LitElement {

	/**
	 * Define stylesheets
	 * @see https://lit.dev/docs/components/styles/
	 * @static
	 */
	static get styles () {
		return [styles];
	}

	/**
	 * Define reflector properties
	 * @see https://lit.dev/docs/components/properties/
	 * @static
	 */
	static get properties () {
		return {
			identifier: {
				type: String
			}
		};
	};

	/**
	 * @constructor
	 */
	constructor () {
		super();

		this.controller = BopisController;
		this.identifier = 0;
	}

	/**
	 * Invoked when a component is added to the document's DOM.
	 * @see https://lit.dev/docs/components/lifecycle/#connectedcallback
	 * @static
	 */
	connectedCallback () {
		super.connectedCallback();
		this.bopisStoreUnsubscribe = this.controller.store.subscribe(() => this.requestUpdate());
	}

	/**
	 * Invoked when a component is removed from the document's DOM.
	 * @see https://lit.dev/docs/components/lifecycle/#disconnectedcallback
	 * @static
	 */
	disconnectedCallback () {
		this.bopisStoreUnsubscribe();
		super.disconnectedCallback();
	}

	get isMyStore () {
		return this.identifier?.toString() === this.controller?.store?.state?.myStore?.identifier?.toString();
	}

	/**
	 * Render the "My Store" flag
	 * @return {html}
	 */
	render () {
		if (!this.isMyStore) {
			return nothing;
		}

		return html`
			<span class="my-store-flag">
				<span class="u-icon-my-store my-store-flag-icon" aria-hidden="true"></span> My Store
			</span>
		`;
	}
};

customElements.define('x-my-store-flag', MyStoreFlag);
